export const NOT_BLANK = /\S+/
export const NO_SPACE_AROUND = /^\S+(\s*\S+)*$/
export const EMAIL =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
export const GROUP_NAME = /^[^\s+'@](\s*[^\s+'@])*$/
